import { ProductDoc, ProductStateCode } from '@gooduncles/gu-app-schema';
import { getProducts } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

type SortKey = 'fullName' | 'price';

const sortLogic = (a: ProductDoc, b: ProductDoc, sortKey: SortKey, orderBy: 'asc' | 'desc') => {
  if (sortKey === 'fullName') {
    return orderBy === 'asc' ? a.fullName.localeCompare(b.fullName) : b.fullName.localeCompare(a.fullName);
  }
  return orderBy === 'asc' ? a.price - b.price : b.price - a.price;
};

const getProrductsForMainTag = async (args: [string, string, ProductDoc['_id'][]]) => {
  const [, mainTag, unhiddenProducts] = args;
  const products = await getProducts([['mainTag', '==', mainTag]]);

  const filteredProducts = products.filter(
    (product) =>
      // 판매중인 상태인 상품만 가져온다.
      [ProductStateCode.STOCK, ProductStateCode.OUTOFSTOCK].includes(product.state) &&
      // hidden 상태인 상품은 제외한다.
      // 단, unhiddenProducts에 포함된 상품은 제외하지 않는다.
      (product.hidden !== true || unhiddenProducts?.includes(product.productId))
  );
  return filteredProducts;
};

/**
 * @param mainTag
 * @param limit 한 번에 가져올 상품 페이지의 개수(한 페이지 당 10개의 상품)
 * @returns
 */
const useProrductsForMainTag = (
  mainTag: string,
  unhiddenProducts: ProductDoc['_id'][],
  sortKey: SortKey = 'fullName',
  orderBy: 'asc' | 'desc' = 'asc'
) => {
  const {
    data,
    isLoading: productsForMainTagLoading,
    error: productsForMainTagError,
  } = useSWR(mainTag ? ['mainTag', mainTag, unhiddenProducts] : null, getProrductsForMainTag, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    productsForMainTag: data?.sort((a, b) => sortLogic(a, b, sortKey, orderBy)) || [],
    productsForMainTagError,
    productsForMainTagLoading,
  };
};

export default useProrductsForMainTag;
